import { render, staticRenderFns } from "./PublicationCard.vue?vue&type=template&id=6fe39d4b&scoped=true&"
import script from "./PublicationCard.vue?vue&type=script&lang=js&"
export * from "./PublicationCard.vue?vue&type=script&lang=js&"
import style0 from "./PublicationCard.vue?vue&type=style&index=0&id=6fe39d4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe39d4b",
  null
  
)

export default component.exports